var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 540 297",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_283_18925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.421 66.2715L222.665 153.288V296.221H462.177V153.288L342.421 66.2715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.421 66.2715L222.665 153.288V296.221H462.177V153.288L342.421 66.2715Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.389 101.3L406.876 175.061V296.221H609.902V175.061L508.389 101.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.389 101.3L406.876 175.061V296.221H609.902V175.061L508.389 101.3Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4618 121.951H-14.1885V159.613H15.4618V121.951Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1042 122.722H-18.8281V108.84H20.1042V122.722Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2573 195.222V296.067H-147.762V195.222L-56.2522 132L35.2573 195.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2573 195.222V296.067H-147.762V195.222L-56.2522 132L35.2573 195.222Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.252 111.517L-158.901 182.692L-147.961 198.508L-56.252 134.969L35.4575 198.508L46.3976 182.692L-56.252 111.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.252 111.517L-158.901 182.692L-147.961 198.508L-56.252 134.969L35.4575 198.508L46.3976 182.692L-56.252 111.517Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.2518 103.924L-166.176 180.143L-154.461 197.081L-56.2518 129.039L41.9572 197.081L53.6725 180.143L-56.2518 103.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.2518 103.924L-166.176 180.143L-154.461 197.081L-56.2518 129.039L41.9573 197.081L53.6725 180.143L-56.2518 103.924Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1889 259.045H-45.4355V204.875H13.1889V259.045Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76563 254.006H-13.9766V209.915H8.76563V254.006Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-41.0137 229.819H8.76657V234.102H-41.0137V229.819Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.546 128.923H294.273C293.899 123.491 289.271 119.194 283.6 119.194C282.322 119.194 281.101 119.424 279.964 119.824C279.973 119.614 279.996 119.407 279.996 119.194C279.996 111.572 273.655 105.393 265.832 105.393C263.731 105.393 261.743 105.85 259.95 106.651C256.459 103.344 251.702 101.3 246.449 101.3C238.633 101.3 231.916 105.817 228.849 112.309C228.264 112.241 227.671 112.196 227.066 112.196C218.832 112.196 212.156 118.7 212.156 126.723C212.156 127.597 212.249 128.449 212.401 129.28C208.824 130.338 206.192 133.648 206.192 137.546C206.192 142.289 210.084 146.169 214.841 146.169H296.546C301.302 146.169 305.194 142.289 305.194 137.546C305.194 132.804 301.302 128.923 296.546 128.923Z",
    fill: "#E5E6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.546 128.923H294.273C293.899 123.491 289.271 119.194 283.6 119.194C282.322 119.194 281.101 119.424 279.964 119.824C279.973 119.614 279.996 119.407 279.996 119.194C279.996 111.572 273.655 105.393 265.832 105.393C263.731 105.393 261.743 105.85 259.95 106.651C256.459 103.344 251.702 101.3 246.449 101.3C238.633 101.3 231.916 105.817 228.849 112.309C228.264 112.241 227.671 112.196 227.066 112.196C218.832 112.196 212.156 118.7 212.156 126.723C212.156 127.597 212.249 128.449 212.401 129.28C208.824 130.338 206.192 133.648 206.192 137.546C206.192 142.289 210.084 146.169 214.841 146.169H296.546C301.302 146.169 305.194 142.289 305.194 137.546C305.194 132.804 301.302 128.923 296.546 128.923Z",
    stroke: "#040606",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.178 80.3335H489.966C490.26 76.0591 493.902 72.6783 498.363 72.6783C499.37 72.6783 500.33 72.859 501.225 73.1743C501.217 73.0088 501.199 72.846 501.199 72.6783C501.199 66.6809 506.189 61.8194 512.344 61.8194C513.997 61.8194 515.561 62.1793 516.972 62.8088C519.719 60.2072 523.462 58.599 527.595 58.599C533.744 58.599 539.03 62.1528 541.443 67.2611C541.904 67.2076 542.37 67.1718 542.846 67.1718C549.325 67.1718 554.577 72.2895 554.577 78.6025C554.577 79.2903 554.504 79.9603 554.384 80.6146C557.199 81.4464 559.27 84.051 559.27 87.1183C559.27 90.8497 556.208 93.9028 552.465 93.9028H488.178C484.435 93.9028 481.373 90.8497 481.373 87.1183C481.373 83.3868 484.435 80.3335 488.178 80.3335Z",
    fill: "#E5E6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.178 80.3335H489.966C490.26 76.0591 493.902 72.6783 498.363 72.6783C499.37 72.6783 500.33 72.859 501.225 73.1743C501.217 73.0088 501.199 72.846 501.199 72.6783C501.199 66.6809 506.189 61.8194 512.344 61.8194C513.997 61.8194 515.561 62.1793 516.972 62.8088C519.719 60.2072 523.462 58.599 527.595 58.599C533.744 58.599 539.03 62.1528 541.443 67.2611C541.904 67.2076 542.37 67.1718 542.846 67.1718C549.325 67.1718 554.577 72.2895 554.577 78.6025C554.577 79.2903 554.504 79.9603 554.384 80.6146C557.199 81.4464 559.27 84.051 559.27 87.1183C559.27 90.8497 556.208 93.9028 552.465 93.9028H488.178C484.435 93.9028 481.373 90.8497 481.373 87.1183C481.373 83.3868 484.435 80.3335 488.178 80.3335Z",
    stroke: "#040606",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.155 65.1026H177.284V100.504H205.155V65.1026Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.517 65.8276H172.921V52.7787H209.517V65.8276Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.968 296.067H29.7803V155.608L131.374 85.4188L232.968 155.608V296.067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.968 296.067H29.7803V155.608L131.374 85.4188L232.968 155.608V296.067Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2217 151.419L29.5592 159.257H233.191L234.529 151.419H28.2217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2217 151.419L29.5592 159.257H233.191L234.529 151.419H28.2217Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.419 84.5853H49.3293L22.3428 151.954H240.406L213.419 84.5853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.419 84.5853H49.3293L22.3428 151.954H240.406L213.419 84.5853Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.854 75.254H185.749V81.4556H197.854V75.254Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.906 67.6409H191.802V73.8425H203.906V67.6409Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.376 87.7858L104.522 110.295V143.855H131.376H158.229V110.295L131.376 87.7858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.376 87.7858L104.522 110.295V143.855H131.376H158.229V110.295L131.376 87.7858Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.365 121.082C148.365 130.438 140.758 138.023 131.375 138.023C121.991 138.023 114.385 130.438 114.385 121.082C114.385 111.727 121.991 104.142 131.375 104.142C140.758 104.142 148.365 111.727 148.365 121.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.365 121.082C148.365 130.438 140.758 138.023 131.375 138.023C121.991 138.023 114.385 130.438 114.385 121.082C114.385 111.727 121.991 104.142 131.375 104.142C140.758 104.142 148.365 111.727 148.365 121.082Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.037 135.855V123.735H146.193C145.089 129.901 140.221 134.755 134.037 135.855ZM116.56 123.735H128.716V135.855C122.532 134.755 117.664 129.901 116.56 123.735ZM128.716 106.309V118.43H116.56C117.664 112.264 122.532 107.41 128.716 106.309ZM146.193 118.43H134.037V106.309C140.221 107.41 145.089 112.264 146.193 118.43ZM131.377 100.157C119.786 100.157 110.39 109.526 110.39 121.082C110.39 132.639 119.786 142.008 131.377 142.008C142.968 142.008 152.364 132.639 152.364 121.082C152.364 109.526 142.968 100.157 131.377 100.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.037 135.855V123.735H146.193C145.089 129.901 140.221 134.755 134.037 135.855ZM116.56 123.735H128.716V135.855C122.532 134.755 117.664 129.901 116.56 123.735ZM128.716 106.309V118.43H116.56C117.664 112.264 122.532 107.41 128.716 106.309ZM146.193 118.43H134.037V106.309C140.221 107.41 145.089 112.264 146.193 118.43V118.43ZM131.377 100.157C119.786 100.157 110.39 109.526 110.39 121.082C110.39 132.639 119.786 142.008 131.377 142.008C142.968 142.008 152.364 132.639 152.364 121.082C152.364 109.526 142.968 100.157 131.377 100.157Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.375 78.3548L93.9756 110.445L104.522 110.295L131.375 87.7855L158.228 110.295L168.774 110.445L131.375 78.3548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.375 78.3548L93.9756 110.445L104.522 110.295L131.375 87.7855L158.228 110.295L168.774 110.445L131.375 78.3548Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.842 287.692H115.226V192.867H152.842V287.692Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.098 190.743V289.815H117.359V285.57H117.357V194.989H150.714V285.57H150.69V289.815H154.973V190.743H113.098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.098 190.743V289.815H117.359V285.57H117.357V194.989H150.714V285.57H150.69V289.815H154.973V190.743H113.098Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.989 296.067H110.082V287.692H157.989V296.067Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.634 232.17H121.438V200.504H146.634V232.17Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.634 279.818H121.438V248.153H146.634V279.818Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.851 241.726C147.851 242.885 146.909 243.822 145.748 243.822C144.586 243.822 143.645 242.885 143.645 241.726C143.645 240.568 144.586 239.628 145.748 239.628C146.909 239.628 147.851 240.568 147.851 241.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.851 241.726C147.851 242.885 146.909 243.822 145.748 243.822C144.586 243.822 143.645 242.885 143.645 241.726C143.645 240.568 144.586 239.628 145.748 239.628C146.909 239.628 147.851 240.568 147.851 241.726Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M87.829 256.827H57.2676V190.743H87.829V256.827Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M209.603 256.827H179.042V190.743H209.603V256.827Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.702 296.221H308.267V10.6985H478.702V296.221Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.987 71.8069H375.979V29.2215H410.987V71.8069Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.301 69.5524H378.155V31.4764H391.301V69.5524Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.891 69.5524H395.745V31.4764H408.891V69.5524Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.484 29.2216V71.807V29.2216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.484 29.2216V71.807",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.996 55.4026H370.973V75.4763H415.996V55.4026Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.226 7.15268H306.742V14.2444H480.226V7.15268Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.922 0.061079H303.048V7.15259H483.922V0.061079Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.061 55.4025H369.905V59.5579H417.061V55.4025Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.033 71.8069H321.025V29.2215H356.033V71.8069Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.347 69.5524H323.201V31.4764H336.347V69.5524Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.936 69.5524H340.79V31.4764H353.936V69.5524Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53 29.2216V71.807V29.2216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53 29.2216V71.807",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.042 55.4026H316.019V75.4763H361.042V55.4026Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.109 55.4025H314.953V59.5579H362.109V55.4025Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.934 71.8069H465.941V29.2215H430.934V71.8069Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.62 69.5524H463.766V31.4764H450.62V69.5524Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.032 69.5524H446.178V31.4764H433.032V69.5524Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.438 29.2216V71.807V29.2216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.438 29.2216V71.807",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.927 55.4026H470.95V75.4763H425.927V55.4026Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.86 55.4025H472.016V59.5579H424.86V55.4025Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.511 134.221H348.503V91.6355H383.511V134.221Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.826 131.967H350.68V93.8903H363.826V131.967Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.413 131.967H368.267V93.8903H381.413V131.967Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.006 91.6357V134.221V91.6357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.006 91.6357V134.221",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.042 117.817H316.552H316.019V137.891H316.552H361.042H415.997V117.817H361.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.042 117.817H316.552H316.019V137.891H316.552H361.042H415.997V117.817H361.042Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.033 194.888H321.025V152.302H356.033V194.888Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.347 192.633H323.201V154.557H336.347V192.633Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.936 192.633H340.79V154.557H353.936V192.633Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53 152.302V194.888V152.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53 152.302V194.888",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.042 178.483H316.019V198.557H361.042V178.483Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.109 178.483H314.953V182.639H362.109V178.483Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.987 259.049H375.979V216.464H410.987V259.049Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.301 256.795H378.155V218.719H391.301V256.795Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.891 256.795H395.745V218.719H408.891V256.795Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.484 216.464V259.049V216.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.484 216.464V259.049",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.996 242.645H370.973V262.719H415.996V242.645Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.061 242.645H369.905V246.8H417.061V242.645Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.033 259.049H321.025V216.464H356.033V259.049Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.347 256.795H323.201V218.719H336.347V256.795Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.936 256.795H340.79V218.719H353.936V256.795Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53 216.464V259.05V216.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53 216.464V259.05",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.042 242.645H316.019V262.719H361.042V242.645Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.109 242.645H314.953V246.8H362.109V242.645Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.934 259.049H465.941V216.464H430.934V259.049Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.62 256.795H463.766V218.719H450.62V256.795Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.032 256.795H446.178V218.719H433.032V256.795Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.438 216.464V259.049V216.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.438 216.464V259.049",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.927 242.645H470.95V262.719H425.927V242.645Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.86 242.645H472.016V246.8H424.86V242.645Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.149994
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.149994
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M340.857 112.303C340.72 112.303 340.591 112.335 340.456 112.343C340.456 112.337 340.458 112.332 340.458 112.326C340.458 109.735 338.348 107.635 335.745 107.635C334.468 107.635 333.314 108.145 332.465 108.966C331.104 107.368 329.099 106.333 326.83 106.333C322.732 106.333 319.41 109.64 319.41 113.72C319.41 114.357 319.516 114.964 319.668 115.553C318.297 116.043 317.312 117.336 317.312 118.869H347.608C347.514 115.229 344.536 112.303 340.857 112.303Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.149994
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M412.735 118.781C413.949 117.472 414.7 115.734 414.7 113.809C414.7 109.729 411.378 106.421 407.28 106.421C403.902 106.421 401.084 108.683 400.186 111.758C400.077 111.749 399.972 111.725 399.86 111.725C399.448 111.725 399.059 111.806 398.687 111.925C397.68 109.462 395.26 107.723 392.425 107.723C388.718 107.723 385.716 110.693 385.668 114.372C385.338 114.288 384.999 114.23 384.643 114.23C382.351 114.23 380.493 116.08 380.493 118.362C380.493 118.505 380.521 118.641 380.536 118.781H412.735Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.109 117.817H315.486H314.953V121.972H315.486H362.109H417.063V117.817H362.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.109 117.817H315.486H314.953V121.972H315.486H362.109H417.063V117.817H362.109Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.457 194.888H438.465V152.302H403.457V194.888Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.142 192.633H436.288V154.557H423.142V192.633Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.555 192.633H418.701V154.557H405.555V192.633Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.961 152.302V194.888V152.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.961 152.302V194.888",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.934 134.221H465.941V91.6355H430.934V134.221Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.62 131.967H463.766V93.8903H450.62V131.967Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.032 131.967H446.178V93.8903H433.032V131.967Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.438 91.6357V134.221V91.6357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.438 91.6357V134.221",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.927 178.483H470.418H470.951V198.557H470.418H425.927H370.973V178.483H425.927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.927 178.483H470.418H470.951V198.557H470.418H425.927H370.973V178.483H425.927Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.86 178.483H471.482H472.015V182.639H471.482H424.86H369.905V178.483H424.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.86 178.483H471.482H472.015V182.639H471.482H424.86H369.905V178.483H424.86Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.927 117.817H470.95V137.891H425.927V117.817Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.86 117.817H472.016V121.972H424.86V117.817Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.823 181.876V296.221H509.302V181.876L613.063 110.19L716.823 181.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.823 181.876V296.221H509.302V181.876L613.063 110.19L716.823 181.876Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.692 296.221H538.66V192.822H603.692V296.221Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.064 86.9638L496.672 167.667L509.076 185.601L613.064 113.556L717.051 185.601L729.456 167.667L613.064 86.9638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.064 86.9638L496.672 167.667L509.076 185.601L613.064 113.556L717.051 185.601L729.456 167.667L613.064 86.9638Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.062 78.3548L488.422 164.778L501.706 183.983L613.062 106.831L724.419 183.983L737.703 164.778L613.062 78.3548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.062 78.3548L488.422 164.778L501.706 183.983L613.062 106.831L724.419 183.983L737.703 164.778L613.062 78.3548Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.971 296.16H173.617C173.12 296.16 172.718 295.76 172.718 295.265V271.402H177.871V295.265C177.871 295.76 177.468 296.16 176.971 296.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.971 296.16H173.617C173.12 296.16 172.718 295.76 172.718 295.265V271.402H177.871V295.265C177.871 295.76 177.468 296.16 176.971 296.16Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.001 296.16H307.647C307.15 296.16 306.747 295.76 306.747 295.265V271.402H311.9V295.265C311.9 295.76 311.498 296.16 311.001 296.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.001 296.16H307.647C307.15 296.16 306.747 295.76 306.747 295.265V271.402H311.9V295.265C311.9 295.76 311.498 296.16 311.001 296.16Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803ZM298.887 246.18L297.857 247.721L297.574 248.143H187.866L185.07 243.962H300.369L299.416 245.386L298.887 246.18ZM175.452 238.838L183.907 251.48L185.104 253.267H300.336L300.886 252.447V252.445L301.532 251.48L305.96 244.86L309.987 238.838H175.452ZM205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642ZM227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722V242.722ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803V242.803ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722V242.722ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803V242.803ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722V242.722ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803V242.803ZM298.887 246.18L297.857 247.721L297.574 248.143H187.866L185.07 243.962H300.369L299.416 245.386L298.887 246.18ZM175.452 238.838L183.907 251.48L185.104 253.267H300.336L300.886 252.447V252.445L301.532 251.48L305.96 244.86L309.987 238.838H175.452ZM205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642V241.642ZM227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727V242.727ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803V242.803ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722V242.722ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803V242.803ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722V242.722ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838ZM205.172 242.803C205.15 242.417 205.126 242.028 205.1 241.642C205.098 241.62 205.065 241.62 205.065 241.642C205.014 242.412 204.96 243.187 204.902 243.962H205.229C205.212 243.576 205.193 243.189 205.172 242.803V242.803ZM227.473 242.722C227.468 242.701 227.437 242.703 227.437 242.727C227.454 243.139 227.473 243.552 227.497 243.962H227.718C227.63 243.552 227.549 243.137 227.473 242.722V242.722ZM298.055 238.838H271.636L270.571 243.962H299.12L298.055 238.838Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.632 288.423H297.278C296.781 288.423 296.378 288.023 296.378 287.528V249.93L309.291 230.624L313.582 233.463L301.531 251.479V287.528C301.531 288.023 301.129 288.423 300.632 288.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.632 288.423H297.278C296.781 288.423 296.378 288.023 296.378 287.528V249.93L309.291 230.624L313.582 233.463L301.531 251.479V287.528C301.531 288.023 301.129 288.423 300.632 288.423Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.164 288.423H184.81C184.313 288.423 183.91 288.023 183.91 287.528V251.481L171.451 232.886L175.739 230.044L189.064 249.929V287.528C189.064 288.023 188.661 288.423 188.164 288.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.164 288.423H184.81C184.313 288.423 183.91 288.023 183.91 287.528V251.481L171.451 232.886L175.739 230.044L189.064 249.929V287.528C189.064 288.023 188.661 288.423 188.164 288.423Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.297 250.705H240.144V224.757H245.297V250.705Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.519 274.054H169.923C168.762 274.054 167.988 272.863 168.464 271.81L171.824 264.381C172.083 263.81 172.654 263.443 173.283 263.443H312.158C312.788 263.443 313.359 263.81 313.617 264.381L316.978 271.81C317.454 272.863 316.68 274.054 315.519 274.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.519 274.054H169.923C168.762 274.054 167.988 272.863 168.464 271.81L171.824 264.381C172.083 263.81 172.654 263.443 173.283 263.443H312.158C312.788 263.443 313.359 263.81 313.617 264.381L316.978 271.81C317.454 272.863 316.68 274.054 315.519 274.054Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.708 234.106H312.732C314.163 234.106 315.324 232.951 315.324 231.527C315.324 230.484 314.699 229.535 313.727 229.142C295.873 221.932 270.576 217.429 242.515 217.429C214.675 217.429 189.553 221.86 171.723 228.971C170.745 229.361 170.115 230.312 170.115 231.36V231.527C170.115 232.951 171.276 234.106 172.708 234.106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.708 234.106H312.732C314.163 234.106 315.324 232.951 315.324 231.527C315.324 230.484 314.699 229.535 313.727 229.142C295.873 221.932 270.576 217.429 242.515 217.429C214.675 217.429 189.553 221.86 171.723 228.971C170.745 229.361 170.115 230.312 170.115 231.36V231.527C170.115 232.951 171.276 234.106 172.708 234.106Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.912 225.094H238.188V220.258H247.912V225.094Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.047 218.976L211.987 221.53",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.357 218.976L219.417 221.53",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.427 293.123L291.082 292.74L293.75 255.758L284.938 255.958C285.56 266.995 285.474 289.497 285.427 293.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.427 293.123L291.082 292.74L293.75 255.758L284.938 255.958C285.56 266.995 285.474 289.497 285.427 293.123Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.43 258.56C266.048 260.073 264.507 260.99 262.987 260.61C261.468 260.23 260.545 258.697 260.927 257.185L261.849 253.537C262.231 252.025 263.772 251.108 265.292 251.488C266.812 251.868 267.734 253.4 267.353 254.912L266.43 258.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.43 258.56C266.048 260.073 264.507 260.99 262.987 260.61C261.468 260.23 260.545 258.697 260.927 257.185L261.849 253.537C262.231 252.025 263.772 251.108 265.292 251.488C266.812 251.868 267.734 253.4 267.353 254.912L266.43 258.56Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.155 258.367C303.537 259.88 305.078 260.797 306.598 260.417C308.117 260.037 309.039 258.504 308.658 256.992L307.736 253.344C307.354 251.832 305.812 250.915 304.293 251.295C302.773 251.675 301.851 253.208 302.233 254.719L303.155 258.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.155 258.367C303.537 259.88 305.078 260.797 306.598 260.417C308.117 260.037 309.039 258.504 308.658 256.992L307.736 253.344C307.354 251.832 305.812 250.915 304.293 251.295C302.773 251.675 301.851 253.208 302.233 254.719L303.155 258.367Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.488 292.74C283.44 289.113 283.24 266.995 283.864 255.958L275.051 255.757L277.719 292.74H283.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.488 292.74C283.44 289.113 283.24 266.995 283.864 255.958L275.051 255.757L277.719 292.74H283.488Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.467 292.595V296.221H273.273C271.834 296.221 272.872 295.214 274.416 294.48C277.291 293.114 277.65 292.74 277.65 292.74L283.467 292.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.467 292.595V296.221H273.273C271.834 296.221 272.872 295.214 274.416 294.48C277.291 293.114 277.65 292.74 277.65 292.74L283.467 292.595Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.29 292.594V296.221H295.91C297.349 296.221 296.311 295.214 294.766 294.48C291.892 293.114 291.321 292.74 291.321 292.74L285.29 292.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.29 292.594V296.221H295.91C297.349 296.221 296.311 295.214 294.766 294.48C291.892 293.114 291.321 292.74 291.321 292.74L285.29 292.594Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.773 291.469V296.203C213.773 296.213 213.781 296.221 213.791 296.221H225.116C226.694 296.221 225.556 294.765 223.862 293.813C220.73 292.053 218.443 291.488 218.412 291.48C218.411 291.48 218.412 291.48 218.411 291.48L214.026 291.231C213.889 291.223 213.773 291.332 213.773 291.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.773 291.469V296.203C213.773 296.213 213.781 296.221 213.791 296.221H225.116C226.694 296.221 225.556 294.765 223.862 293.813C220.73 292.053 218.443 291.488 218.412 291.48C218.411 291.48 218.412 291.48 218.411 291.48L214.026 291.231C213.889 291.223 213.773 291.332 213.773 291.469Z",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.059 291.644V296.203C231.059 296.213 231.067 296.221 231.077 296.221H243.176C244.82 296.221 243.634 295.013 241.869 294.021C238.603 292.186 236.147 291.75 236.118 291.745C236.117 291.745 236.117 291.745 236.117 291.745L231.077 291.626C231.067 291.626 231.059 291.634 231.059 291.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.059 291.644V296.203C231.059 296.213 231.067 296.221 231.077 296.221H243.176C244.82 296.221 243.634 295.013 241.869 294.021C238.603 292.186 236.147 291.75 236.118 291.745C236.117 291.745 236.117 291.745 236.117 291.745L231.077 291.626C231.067 291.626 231.059 291.634 231.059 291.644Z",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.167 201.313C233.167 210.587 224.646 218.106 216.724 218.106C208.802 218.106 200.281 210.587 200.281 201.313C200.281 192.037 207.643 184.519 216.724 184.519C225.805 184.519 233.167 192.037 233.167 201.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.167 201.313C233.167 210.587 224.646 218.106 216.724 218.106C208.802 218.106 200.281 210.587 200.281 201.313C200.281 192.037 207.643 184.519 216.724 184.519C225.805 184.519 233.167 192.037 233.167 201.313Z",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.987 221.53C208.494 221.748 198.642 228.541 197.921 239.791C197.508 246.239 195.51 261.664 196.12 266.317C196.73 270.97 196.255 267.721 196.552 269.544C196.85 271.368 196.495 269.717 196.819 271.216C197.143 272.717 198.618 273.935 200.419 273.916C202.221 273.897 203.126 272.002 203.105 270.861C203.085 269.719 202.643 269.332 202.829 268.788C203.017 268.241 203.984 268.958 204.351 268.572C204.355 268.568 204.357 268.562 204.356 268.557C203.955 263.62 203.984 257.027 203.728 252.354C203.471 247.677 204.747 242.252 205.106 238.733C205.929 230.643 208.119 225.9 215.914 229.801C216.203 229.946 215.878 229.973 216.058 230.151C220.825 234.838 227.14 229.383 228.622 238.207C230.104 247.031 230.357 259.592 238.566 266.605C238.996 266.982 239.64 266.22 240.022 266.587C240.575 267.118 240.485 267.33 240.952 268.384C241.419 269.439 243.054 270.977 244.62 270.81C246.187 270.643 247.654 268.986 247.462 267.748C247.371 266.791 246.947 265.893 246.262 265.215C246.016 264.972 245.798 264.75 245.615 264.56C245.295 264.229 244.963 263.911 244.599 263.63C240.35 260.348 234.172 245.782 234.348 238.914C234.664 226.613 221.189 221.057 219.374 221.427",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.987 221.53C208.494 221.748 198.642 228.541 197.921 239.791C197.508 246.239 195.51 261.664 196.12 266.317C196.73 270.97 196.255 267.721 196.552 269.544C196.85 271.368 196.495 269.717 196.819 271.216C197.143 272.717 198.618 273.935 200.419 273.916C202.221 273.897 203.126 272.002 203.105 270.861C203.085 269.719 202.643 269.332 202.829 268.788C203.017 268.241 203.984 268.958 204.351 268.572C204.355 268.568 204.357 268.562 204.356 268.557C203.955 263.62 203.984 257.027 203.728 252.354C203.471 247.677 204.747 242.252 205.106 238.733C205.929 230.643 208.119 225.9 215.914 229.801C216.203 229.946 215.878 229.973 216.058 230.151C220.825 234.838 227.14 229.383 228.622 238.207C230.104 247.031 230.357 259.592 238.566 266.605C238.996 266.982 239.64 266.22 240.022 266.587C240.575 267.118 240.485 267.33 240.952 268.384C241.419 269.439 243.054 270.977 244.62 270.81C246.187 270.643 247.654 268.986 247.462 267.748C247.371 266.791 246.947 265.893 246.262 265.215C246.016 264.972 245.798 264.75 245.615 264.56C245.295 264.229 244.963 263.911 244.599 263.63C240.35 260.348 234.172 245.782 234.348 238.914C234.664 226.613 221.189 221.057 219.374 221.427",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.048 226.202C214.629 226.295 212.792 222.937 211.988 221.53C211.769 221.147 211.627 220.908 211.591 220.924C202.15 224.961 200.237 224.456 197.818 236.888C197.296 239.574 195.037 258.48 195.472 262.684C195.838 266.217 201.561 263.29 203.486 263.589C203.783 263.635 204.051 263.412 204.032 263.114C203.586 255.912 204.562 247.814 205.065 240.023C205.067 240.001 205.1 240.002 205.101 240.024C205.553 246.567 205.283 253.04 205.034 259.585C205.034 259.595 205.043 259.604 205.053 259.604C212.938 259.113 220.81 258.846 228.709 258.697C228.719 258.697 228.727 258.688 228.726 258.678C228.139 252.805 227.692 247.006 227.439 241.108C227.438 241.086 227.469 241.082 227.473 241.104C228.833 248.457 231.608 255.032 233.202 262.234C233.204 262.244 233.213 262.25 233.223 262.248C235.935 261.733 239.232 260.832 242.004 260.677C242.017 260.676 242.025 260.662 242.018 260.651C237.439 252.596 235.324 240.65 233.057 232.418C230.787 224.178 227.052 223.178 220.84 220.555C219.319 219.913 217.854 226.084 216.048 226.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.048 226.202C214.629 226.295 212.792 222.937 211.988 221.53C211.769 221.147 211.627 220.908 211.591 220.924C202.15 224.961 200.237 224.456 197.818 236.888C197.296 239.574 195.037 258.48 195.472 262.684C195.838 266.217 201.561 263.29 203.486 263.589C203.783 263.635 204.051 263.412 204.032 263.114C203.586 255.912 204.562 247.814 205.065 240.023C205.067 240.001 205.1 240.002 205.101 240.024C205.553 246.567 205.283 253.04 205.034 259.585C205.034 259.595 205.043 259.604 205.053 259.604C212.938 259.113 220.81 258.846 228.709 258.697C228.719 258.697 228.727 258.688 228.726 258.678C228.139 252.805 227.692 247.006 227.439 241.108C227.438 241.086 227.469 241.082 227.473 241.104C228.833 248.457 231.608 255.032 233.202 262.234C233.204 262.244 233.213 262.25 233.223 262.248C235.935 261.733 239.232 260.832 242.004 260.677C242.017 260.676 242.025 260.662 242.018 260.651C237.439 252.596 235.324 240.65 233.057 232.418C230.787 224.178 227.052 223.178 220.84 220.555C219.319 219.913 217.854 226.084 216.048 226.202Z",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.683 209.368C223.367 209.368 219.113 212.295 216.683 212.295C214.86 212.295 210.604 209.368 216.683 209.368ZM232.978 203.158L231.663 204.692C231.66 204.692 231.66 204.694 231.66 204.694C231.372 205.142 231.105 205.55 230.848 205.919C229.465 207.908 228.365 208.813 225.72 208.977C222.833 209.155 220.446 206.37 217.641 205.919C217.395 205.877 217.145 205.856 216.89 205.856C216.635 205.856 216.385 205.877 216.139 205.919C213.332 206.37 210.944 209.155 208.058 208.977C204.92 208.782 202.439 206.398 200.602 203.547C200.599 203.544 200.599 203.542 200.599 203.54L200.38 202.243C200.38 202.656 200.401 203.073 200.442 203.495C200.442 203.497 200.442 203.502 200.444 203.507C200.444 203.516 200.447 203.526 200.447 203.535C200.931 208.503 204.093 214.011 207.567 216.343C208.525 216.988 209.372 217.497 210.156 217.898C211.183 218.422 212.105 218.761 213.046 218.976C214.223 219.244 215.424 219.32 216.89 219.32C217.457 219.32 217.984 219.308 218.484 219.28C221.113 219.126 223.038 218.474 226.21 216.343C226.22 216.336 226.23 216.331 226.239 216.324C229.335 214.231 231.918 210.207 232.735 205.919C232.888 205.128 232.981 204.329 233.002 203.531V203.528C233.007 203.409 233.009 203.288 233.009 203.17C233.009 203.153 232.988 203.146 232.978 203.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.683 209.368C223.367 209.368 219.113 212.295 216.683 212.295C214.86 212.295 210.604 209.368 216.683 209.368ZM232.978 203.158L231.663 204.692C231.66 204.692 231.66 204.694 231.66 204.694C231.372 205.142 231.105 205.55 230.848 205.919C229.465 207.908 228.365 208.813 225.72 208.977C222.833 209.155 220.446 206.37 217.641 205.919C217.395 205.877 217.145 205.856 216.89 205.856C216.635 205.856 216.385 205.877 216.139 205.919C213.332 206.37 210.944 209.155 208.058 208.977C204.92 208.782 202.439 206.398 200.602 203.547C200.599 203.544 200.599 203.542 200.599 203.54L200.38 202.243C200.38 202.656 200.401 203.073 200.442 203.495C200.442 203.497 200.442 203.502 200.444 203.507C200.444 203.516 200.447 203.526 200.447 203.535C200.931 208.503 204.093 214.011 207.567 216.343C208.525 216.988 209.372 217.497 210.156 217.898C211.183 218.422 212.105 218.761 213.046 218.976C214.223 219.244 215.424 219.32 216.89 219.32C217.457 219.32 217.984 219.308 218.484 219.28C221.113 219.126 223.038 218.474 226.21 216.343C226.22 216.336 226.23 216.331 226.239 216.324C229.335 214.231 231.918 210.207 232.735 205.919C232.888 205.128 232.981 204.329 233.002 203.531V203.528C233.007 203.409 233.009 203.288 233.009 203.17C233.009 203.153 232.988 203.146 232.978 203.158V203.158Z",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.72 258.697C228.725 258.697 228.729 258.698 228.733 258.702C228.935 258.906 234.973 264.362 235.251 264.639C235.461 264.848 238.66 267.935 240.144 270.074C242.327 273.219 240.962 276.913 240.568 277.709L235.716 291.613C235.714 291.62 235.724 291.613 235.716 291.613L231.077 291.626C231.058 291.924 231.06 290.927 231.061 290.917L232.098 281.358C232.114 280.915 232.13 280.474 232.146 280.031L231.937 274.082C231.906 273.182 231.374 272.373 230.557 271.985L223.24 268.505C223.225 268.497 223.209 268.512 223.215 268.528L225.039 270.669C225.867 271.641 226.224 272.945 225.939 274.188C225.918 274.281 225.895 274.365 225.869 274.44L218.542 291.207C218.536 291.211 218.532 291.214 218.527 291.218L213.92 291.479C213.909 291.479 213.9 291.471 213.901 291.46L215.036 274.411C215.114 273.231 214.25 272.886 213.15 272.436L210.503 271.492C208.28 270.7 206.642 268.784 206.231 266.463L206.223 266.416L205.036 259.625C205.035 259.614 205.042 259.604 205.053 259.604L228.72 258.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.72 258.697C228.725 258.697 228.729 258.698 228.733 258.702C228.935 258.906 234.973 264.362 235.251 264.639C235.461 264.848 238.66 267.935 240.144 270.074C242.327 273.219 240.962 276.913 240.568 277.709L235.716 291.613C235.714 291.62 235.724 291.613 235.716 291.613L231.077 291.626C231.058 291.924 231.06 290.927 231.061 290.917L232.098 281.358C232.114 280.915 232.13 280.474 232.146 280.031L231.937 274.082C231.906 273.182 231.374 272.373 230.557 271.985L223.24 268.505C223.225 268.497 223.209 268.512 223.215 268.528L225.039 270.669C225.867 271.641 226.224 272.945 225.939 274.188C225.918 274.281 225.895 274.365 225.869 274.44L218.542 291.207C218.536 291.211 218.532 291.214 218.527 291.218L213.92 291.479C213.909 291.479 213.9 291.471 213.901 291.46L215.036 274.411C215.114 273.231 214.25 272.886 213.15 272.436L210.503 271.492C208.28 270.7 206.642 268.784 206.231 266.463L206.223 266.416L205.036 259.625C205.035 259.614 205.042 259.604 205.053 259.604L228.72 258.697Z",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.677 227.969C302.677 218.137 298.66 212.574 289.545 211.067V207.977H279.821V211.067C270.705 212.574 266.848 218.137 266.848 227.969L261.052 255.292L267.546 256.891L273.808 226.78C273.808 219.15 276.849 219.879 284.284 219.922L284.276 220.021C292.051 220.01 295.881 218.992 295.881 226.78L302.148 256.891L308.55 255.292L302.677 227.969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.677 227.969C302.677 218.137 298.66 212.574 289.545 211.067V207.977H279.821V211.067C270.705 212.574 266.848 218.137 266.848 227.969L261.052 255.292L267.546 256.891L273.808 226.78C273.808 219.15 276.849 219.879 284.284 219.922L284.276 220.021C292.051 220.01 295.881 218.992 295.881 226.78L302.148 256.891L308.55 255.292L302.677 227.969Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.226 193.059C301.226 202.333 292.704 209.853 284.783 209.853C276.861 209.853 268.34 202.333 268.34 193.059C268.34 183.784 275.702 176.265 284.783 176.265C293.865 176.265 301.226 183.784 301.226 193.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.226 193.059C301.226 202.333 292.704 209.853 284.783 209.853C276.861 209.853 268.34 202.333 268.34 193.059C268.34 183.784 275.702 176.265 284.783 176.265C293.865 176.265 301.226 183.784 301.226 193.059Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.905 231.617L303.849 231.432C303.849 231.432 303.167 225.176 301.976 220.35C300.221 213.245 292.565 211.658 292.565 211.658C292.565 211.658 291.293 216.619 284.84 216.741C278.388 216.619 277.117 211.658 277.117 211.658C277.117 211.658 269.46 213.245 267.706 220.35C266.514 225.176 265.832 231.418 265.832 231.418L273.776 231.617L273.798 241.881C268.815 251.227 266.098 270.467 266.098 270.467C266.098 270.467 266.643 274.355 284.893 274.355C303.141 274.355 303.687 270.467 303.687 270.467C303.687 270.467 300.932 251.054 295.884 241.688L295.905 231.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.905 231.617L303.849 231.432C303.849 231.432 303.167 225.176 301.976 220.35C300.221 213.245 292.565 211.658 292.565 211.658C292.565 211.658 291.293 216.619 284.84 216.741C278.388 216.619 277.117 211.658 277.117 211.658C277.117 211.658 269.46 213.245 267.706 220.35C266.514 225.176 265.832 231.418 265.832 231.418L273.776 231.617L273.798 241.881C268.815 251.227 266.098 270.467 266.098 270.467C266.098 270.467 266.643 274.355 284.893 274.355C303.141 274.355 303.687 270.467 303.687 270.467C303.687 270.467 300.932 251.054 295.884 241.688L295.905 231.617Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.133 185.311C286.133 185.311 281.167 192.768 275.05 194.982C270.535 196.617 270.114 194.378 270.114 194.378L270.486 200.939C270.486 200.939 263.649 191.96 270.029 182.894C276.409 173.828 284.788 173.651 292.21 175.641C301.225 178.059 306.795 194.68 298.895 201.933L297.763 194.982C297.763 194.982 294.033 196.191 286.133 185.311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.133 185.311C286.133 185.311 281.167 192.768 275.05 194.982C270.535 196.617 270.114 194.378 270.114 194.378L270.486 200.939C270.486 200.939 263.649 191.96 270.029 182.894C276.409 173.828 284.788 173.651 292.21 175.641C301.225 178.059 306.795 194.68 298.895 201.933L297.763 194.982C297.763 194.982 294.033 196.191 286.133 185.311V185.311Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.846 144.411H336.105C336.105 141.656 333.852 139.415 331.081 139.415C328.312 139.415 326.058 141.656 326.058 144.411H323.317C323.317 140.153 326.8 136.689 331.081 136.689C335.363 136.689 338.846 140.153 338.846 144.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.846 144.411H336.105C336.105 141.656 333.852 139.415 331.081 139.415C328.312 139.415 326.058 141.656 326.058 144.411H323.317C323.317 140.153 326.8 136.689 331.081 136.689C335.363 136.689 338.846 140.153 338.846 144.411Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.336 144.643C334.336 142.854 332.878 141.404 331.08 141.404C329.281 141.404 327.823 142.854 327.823 144.643H334.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.336 144.643C334.336 142.854 332.878 141.404 331.08 141.404C329.281 141.404 327.823 142.854 327.823 144.643H334.336Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.818 143.717H323.342L319.786 149.453H342.373L338.818 143.717Z",
    fill: "#F14E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.818 143.717H323.342L319.786 149.453H342.373L338.818 143.717Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.636 188.84L331.08 197.28L340.523 188.84V188.595",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.636 188.84L331.08 197.28L340.523 188.84V188.595",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4 251.737H327.76V178.259H334.4V251.737Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.314 251.737H325.848V240.289H336.314V251.737Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.818 179.401H323.342L319.786 149.453H342.373L338.818 179.401Z",
    fill: "#F14E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.818 179.401H323.342L319.786 149.453H342.373L338.818 179.401Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.818 179.401H323.342L319.786 149.453H342.373L338.818 179.401Z",
    fill: "#F14E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.818 179.401H323.342L319.786 149.453H342.373L338.818 179.401Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.818 179.401H323.342L319.786 157.747H342.373L338.818 179.401Z",
    fill: "#F14E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.818 179.401H323.342L319.786 157.747H342.373L338.818 179.401Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.634 149.166C343.588 148.958 343.487 148.76 343.342 148.598C343.095 148.324 342.745 148.166 342.375 148.166H319.787C319.417 148.166 319.066 148.324 318.82 148.598C318.576 148.872 318.458 149.24 318.504 149.605L319.854 160.971L322.059 179.552C322.136 180.199 322.688 180.689 323.344 180.689H338.82C339.474 180.689 340.026 180.199 340.103 179.552L341.842 164.919L343.634 149.831L343.661 149.605C343.679 149.456 343.669 149.307 343.634 149.166Z",
    fill: "#F14E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.634 149.166C343.588 148.958 343.487 148.76 343.342 148.598C343.095 148.324 342.745 148.166 342.375 148.166H319.787C319.417 148.166 319.066 148.324 318.82 148.598C318.576 148.872 318.458 149.24 318.504 149.605L319.854 160.971L322.059 179.552C322.136 180.199 322.688 180.689 323.344 180.689H338.82C339.474 180.689 340.026 180.199 340.103 179.552L341.842 164.919L343.634 149.831L343.661 149.605C343.679 149.456 343.669 149.307 343.634 149.166Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.523 188.742H321.636V185.125C321.636 185.089 321.664 185.061 321.699 185.061H340.46C340.495 185.061 340.523 185.089 340.523 185.125V188.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.523 188.742H321.636V185.125C321.636 185.089 321.664 185.061 321.699 185.061H340.46C340.495 185.061 340.523 185.089 340.523 185.125V188.742Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.611 296.221H323.549V247.73H338.611V296.221Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M545.534 174.548C545.534 190.765 532.348 203.911 516.084 203.911C499.819 203.911 486.634 190.765 486.634 174.548C486.634 158.33 499.819 145.184 516.084 145.184C532.348 145.184 545.534 158.33 545.534 174.548Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M467.894 197.459C467.894 208.779 458.69 217.956 447.336 217.956C435.982 217.956 426.778 208.779 426.778 197.459C426.778 186.138 435.982 176.961 447.336 176.961C458.69 176.961 467.894 186.138 467.894 197.459Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M512.282 138.827C512.282 160.184 494.918 177.498 473.498 177.498C452.078 177.498 434.714 160.184 434.714 138.827C434.714 117.47 452.078 100.157 473.498 100.157C494.918 100.157 512.282 117.47 512.282 138.827Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.28 164.868L474.891 220.508",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.89 230.943L447.335 195.608",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.891 118.435V296.675",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_18925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 297,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a065858d.svg";
export { ForwardRef as ReactComponent };